import {createAsyncThunk} from "@reduxjs/toolkit";
import {executePromise} from "../util/sliceUtil";
import {TestResultApi} from "../api/TestResultApi";

export const getKpassTestResultAsync = createAsyncThunk("testResult/getKpassTestResult",
    ({ executedInfo, token }: { executedInfo: number; token: string }) =>
        executePromise(TestResultApi.getKpassTestResult(executedInfo, token))
);